const buildCategoryStateObject = async (response, locale = 'en', cleanHtml = true) => {
  const { HTMLCleaner } = await import('@/utils/html_cleaner');
  const {
    id,
    version,
    key,
    name,
    orderHint,
    description: descriptionRaw,
    assets,
    childCount,
    stagedProductCount,
    custom,
    ancestors,
  } = response;
  const categoryState = {
    id,
    version,
    key,
    name,
    orderHint,
    description: cleanHtml ? HTMLCleaner.clean(descriptionRaw) : '',
    assets,
    childCount,
    stagedProductCount,
    ancestors,
    path: '',
  };

  const customFieldsRaw = custom ? custom.customFieldsRaw : null;

  if (customFieldsRaw) {
    const desiredCustomFields = [
      'isB2b',
      'sidebarTop',
      'sidebarBottom',
      'topDescription',
      'wholesaleDescription',
      'urlName',
      'hidden',
    ];
    const customFields = customFieldsRaw.filter((attribute) =>
      desiredCustomFields.includes(attribute.name),
    );
    customFields.forEach(({ name: attributeName, value: valueObj }) => {
      let value = Object.prototype.hasOwnProperty.call(valueObj, locale)
        ? valueObj[locale]
        : valueObj;

      if (attributeName === 'topDescription' && !value.includes('[noparse]')) {
        value = `[noparse]${value}[/noparse]`;
      }
      if (attributeName === 'topDescription' || attributeName === 'wholesaleDescription') {
        categoryState[attributeName] = cleanHtml ? HTMLCleaner.clean(value) : '';
      } else if (attributeName === 'sidebarTop' || attributeName === 'sidebarBottom') {
        categoryState[attributeName] = value.map((item) => item[locale]);
      } else {
        categoryState[attributeName] = value;
      }
    });
  }

  const path = ancestors
    .map((ancestor) => ancestor.custom?.customFieldsRaw?.find((f) => f.name === 'urlName')?.value)
    .join('/');
  categoryState.path = `${path}/${categoryState.urlName}/`;

  return categoryState;
};

export default {
  buildCategoryStateObject,
};
